import React from "react";
import "../Styles/ApprovedProfiles.css";

export const Liked = 1;
export const UnLiked = 2;
export const Saved = 3;
export const Shared = 4;
export const Approved = 5;

const ApprovedProfilesForClient = ({ profiles = [], moveToMatches }) => {
  const approvedProfiles = profiles.filter(
    (item) => item.MatchInfo?.Client1Status === Approved,
  );

  return (
    <div className="approved-wrapper p-4">
      <h2 className="approved-title">Approved Profiles</h2>

      <div className="profile-card-container">
        {approvedProfiles.length === 0 ? (
          <div className="no-data-message">No approved profiles found.</div>
        ) : (
          approvedProfiles.map((profile, index) => (
            <div
              className="profile-card-box click-effect"
              key={index}
              onClick={() => moveToMatches(profile.ProfileId)}
            >
              <img
                className="profile-avatar"
                src={
                  profile?.User?.ProfilePhotoUrl
                    ? profile.User.ProfilePhotoUrl
                    : "https://randomuser.me/api/portraits/women/44.jpg"
                }
                alt="profile"
              />
              <div className="profile-text-content">
                <h3 className="profile-fullname">
                  {profile?.User?.FirstName} {profile?.User?.LastName}
                </h3>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ApprovedProfilesForClient;
